import React from 'react';



const Facts=()=>{








  return(
    <section>
    <details >
    <summary>Some facts about the Internation Space Station</summary>
    <ul>
    <li>
    The ISS travels at 15,500 miles per hour, or 7 kilometers PER SECOND!
    </li>
    <li>
    This means the ISS travels around the world 16 times a day.
    </li>
    <li>
    Has been continuously occupied since November 2000 (source <a href="https://www.nasa.gov/feature/facts-and-figures"> NASA</a>)
    </li>

    </ul>
    </details>
    </section>

  )
}

export default Facts
